import forEach from 'lodash/forEach';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import differenceWith from 'lodash/differenceWith';
import first from 'lodash/first';
import * as actions from '../actions/ShippingAddressFormActions';

export default class AddressDetailsModel {
    constructor(addressListResponse) {
        this.addressDetails = addressListResponse;
        this.addresses = [];
    }

    addAddressesToAddressList() {
        let addresses = [];
        forEach(this.addressDetails.response.data.data, (address) => {
            const accountAddress = {
                address: {
                    lineOne: address.addressLineOne,
                    lineTwo: address.addressLineTwo,
                    city: address.militaryAddressType ? address.militaryAddressType : address.city,
                    state: address.state ? address.state : '',
                    country: address.country,
                    zip: address.zip,
                    phone: address.phone,
                    firstName: address.firstName,
                    lastName: address.lastName,
                    militaryAddressType: address.militaryAddressType,
                    id: address.id,
                    isDefault: address.isDefault,
                    expressCheckout: address.expressCheckout,
                    company: address.company,
                },
            };
            addresses.push(accountAddress);
        });
        addresses.reverse();
        addresses = sortBy(
            addresses,
            (item) => !item.address.isDefault && !item.address.expressCheckout
        );
        this.addresses = addresses;
        return actions.addAddressesToAddressList(addresses);
    }

    setDefaultAddress(currentSelectedAddress) {
        let selectedAddress;
        if (currentSelectedAddress && currentSelectedAddress.id) {
            selectedAddress = find(
                this.addressDetails.response.data.data,
                (item) => item.id === currentSelectedAddress.id
            );
        }
        let tempAddress = {};
        tempAddress = find(
            this.addressDetails.response.data.data,
            (address) => address.expressCheckout === true
        );
        isEmpty(tempAddress) &&
            (tempAddress = find(
                this.addressDetails.response.data.data,
                (address) => address.isDefault === true
            ));
        let defaultAddress = {};
        !isEmpty(tempAddress) &&
            (defaultAddress = {
                lineOne: tempAddress.addressLineOne,
                lineTwo: tempAddress.addressLineTwo,
                city: tempAddress.city,
                state: tempAddress.state ? tempAddress.state : '',
                country: tempAddress.country,
                zip: tempAddress.zip,
                phone: tempAddress.phone,
                firstName: tempAddress.firstName,
                lastName: tempAddress.lastName,
                militaryAddressType: tempAddress.militaryAddressType,
                id: tempAddress.id,
                isDefault: tempAddress.isDefault,
                expressCheckout: tempAddress.expressCheckout,
                company: tempAddress.company,
            });
        return actions.setDefaultAddress(defaultAddress, selectedAddress);
    }

    getUpdatedAddress(updatingAddressId, addressList) {
        let updatedAddress;
        if (updatingAddressId) {
            updatedAddress = find(
                this.addresses,
                (address) => address.address.id === updatingAddressId
            );
        } else {
            updatedAddress = first(
                differenceWith(
                    this.addresses,
                    addressList,
                    // Custom comparator as relationship id is present in the address object once it is
                    // added to the order and the differenceWith with equal comparator always picks that
                    (arrVal, othVal) => arrVal.address.id === othVal.address.id
                )
            );
        }
        return updatedAddress;
    }
}
